<app-scan-panel title="Scannez votre QR code">
  Veuillez scanner le <strong>QR code</strong> reçu avec votre invitation email
  devant le lecteur situé en bas de l'écran
</app-scan-panel>
